module.exports = __webpack_public_path__ + "static/media/web.b2408b03.png";